export default "__VITE_ASSET__BEvDVt9W__"